module.exports = "32"